<template>
  <div>
  <header-mx></header-mx>
    <section class="main dashboard">
      <div class="figuras top">
        <!-- <div class="container-fluid pb-3">
          <div class="row">
            <div class="col-sm-12">
              <div class="row" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500">
                 <div class="col-md-6 pt-4">
                  <h2 class="naranja">¡Hola Juan!</h2>
                  <h2>¿Qué necesitas hacer?</h2>
                </div>

                <div class="col-md-6 pt-4">
                  <div class="float-md-right">
                    <div class="status">
                      <div>
                        <i class="far fa-check-circle fa-2x"></i>
                      </div>
                      <div>
                        <div>Contrato activo</div>
                        <div>Vigencia: 20 de marzo de 2020</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->

        <div class="pt-3">
          <div
            class="row no-gutters"
            data-aos="fade-right"
            data-aos-delay="10"
            data-aos-duration="500"
          >
            <menu-lat></menu-lat>

            <div class="col-md-10">
              <div class="row headercontenido">
                <div class="col-6 col-md-6">
                  <span class="titulo sub">
                    <router-link to="/dashboard/asignaturas">Asignaturas</router-link>
                    <i class="fa fa-chevron-right"></i> Actualizacion de datos
                  </span>
                </div>
                <div class="col-6 col-md-6">
                  <!-- <button class="btnblanco float-right">
                    Nuevo alumno
                    <i class="fa fa-plus-circle"></i>
                  </button>-->
                </div>
              </div>

              <div class="contenido">
                <div class="row">
                  <div class="col-12 col-lg-10 offset-lg-1 pb-3">
                    <div class="formulario col-12 bggris rounded pt-5 pb-4 card">
                      <h2 class="text-center mb-3 pb-2">Actualización de datos</h2>
                      <form method="post" @submit="submitFormulario($event)">
                        <label>
                          <span>Programa Académico:</span>
                         <input
                            type="text"
                            v-model="form.nombre"
                            maxlength="100"
                            placeholder="Clave"
                            required
                            disabled
                          />
                        </label>

                        <label>
                          <span>Clave:</span>
                          <input
                            type="text"
                            v-model="form.clave"
                            maxlength="100"
                            placeholder="Clave"
                            required
                            disabled
                          />
                        </label>

                        <label>
                          <span>Nombre Asignatura:</span>
                          <input
                            type="text"
                            v-model="form.asignatura"
                            maxlength="100"
                            placeholder="Nombre Asignatura"
                            required
                          />
                        </label>

                        <label>
                          <span>Créditos:</span>
                          <input
                            type="text"
                            v-model="form.creditos"
                            maxlength="100"
                            placeholder="Créditos"
                            required
                          />
                        </label>

                        <label>
                          <span>Seriación:</span>
                          <select required v-model="form.seriacion">
                            <option value hidden>Seriación</option>

                            <option
                              :value="item.id"
                              v-for="item in this.seriaciones"
                              v-bind:key="item.id"
                            >{{item.asignaturamod}}</option>
                          </select>
                        </label>

                        <div class="text-center pt-2">
                          <button type="submit" class="submit btnblanco">Actualizar datos</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <span class="loading" v-bind:class="{active: this.$store.state.loading}">
                  <img src="../../assets/imgs/DualRing-1.1s-28px.svg" alt="loading" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../../Components/Header.vue";
import Menu from "../../Components/Menu.vue";
import { ServerTable, ClientTable, Event } from "vue-tables-2";

import Vue from "vue";
Vue.use(ClientTable);

export default {
  name: "IEEServiciosAcademicos",
  props: {
    msg: String
  },
  data() {
    return {
      form: {
        nombre:"",
        codigo: "",
        clave: "",
        asignatura: "",
        creditos: "",
        seriacion: ""
      },

      columns: [
        "matricula",
        "nombre",
        "user_email",
        "grupos",
        "uri",
        "baja",
        "bloqueo"
      ],
      datos: null,
      data: null,
      programas: null,
      seriaciones: null,
      options: {
        perPage: 5,
        perPageValues: [5, 10, 15, 25, 50, 100],
        headings: {
          matricula: "Matrícula",
          nombre: "Nombre",
          user_email: "Email",
          grupos: "Grupos",
          uri: "Actualización de datos",
          baja: "Baja",
          bloqueo: "Bloqueo"
        },
        editableColumns: ["name"],
        sortable: ["nombre"],
        pagination: {
          show: true,
          dropdown: false,
          chunk: 10,
          edge: true,
          align: "center",
          nav: "fixed"
        },
        texts: {
          count:
            "Mostrando desde {from} hasta {to} - {count} registros|{count} registros|Un registro",
          first: "Primera",
          last: "Última",
          filter: "",
          filterPlaceholder: "Búsqueda",
          limit: "",
          page: "Página:",
          noResults: "No se encontraron resultados.",
          filterBy: "Filtrando por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas"
        }
      }
    };
  },
  components: {
    "header-mx": Header,
    "menu-lat": Menu
  },
  mounted: function() {
  this.$store.state.user = JSON.parse(this.$cookie.get('useriee'));
    AOS.init();

    this.form.codigo = this.$route.params.codigo;
    this.form.clave = this.$route.params.clave;

    
    this.buscaSeriaciones();
  },
  methods: {
    buscaSeriaciones() {
      console.log("consulta");

      this.seriaciones = null;

      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        id_plantel: this.$store.state.user.id_plantel,
        codigo: this.form.codigo
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(
          vm.$store.state.baseurl +
            "asignaturas/consulta-alta-asignatura-seriaciones.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data"
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            }
          }
        )
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.seriaciones = res.datos;
              this.consulta();
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    consulta() {
      console.log("consulta");

      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        id_plantel: this.$store.state.user.id_plantel,
        codigo: this.form.codigo,
        clave: this.form.clave
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(
          vm.$store.state.baseurl + "asignaturas/consulta-actualizacion-asignatura.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data"
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            }
          }
        )
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.form.nombre = res.datos[0].nombre;
              this.form.asignatura = res.datos[0].asignatura;
              this.form.creditos = res.datos[0].creditos;
              this.form.seriacion = res.datos[0].seriacion;
              
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    submitFormulario(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      const https = require("https");

      vm.$store.state.loading = true;

      var qData = {
        form: this.form,
        id_plantel: this.$store.state.user.id_plantel
      };

      let formData = new FormData();

      formData.append("form_data", JSON.stringify(qData));
      //formData.append("cv", this.file);

      console.log("enviando");
      //console.log(this.file);
      console.log(JSON.stringify(qData));

      this.$http
        .post(
          vm.$store.state.baseurl + "asignaturas/actualizacion-asignatura.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data"
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            }
          }
        )
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              swal.fire("Bien", res.msg, "success");
              
              
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    }
  }
};
</script>

